import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'

import { useGET_groupCourseByIdQuery } from 'redux/api/groupCoursesApi'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import CourseInfo from 'components/molecules/CourseInfo'
import Tabs from 'components/organisms/tabs/Tabs'

import GroupCourseAssignments from 'components/utilized/groupCourses/GroupCourseAssignments'
import GroupCourseGradebook from 'components/utilized/groupCourses/GroupCourseGradebook'
import GroupCourseLessons from 'components/utilized/groupCourses/GroupCourseLessons'
import GroupCourseLessonPlans from 'components/utilized/groupCourses/GroupCourseLessonPlans'
import GroupCourseEnrolledTeachers from 'components/utilized/groupCourses/GroupCourseEnrolledTeachers'
import GroupCourseEnrolledStudents from 'components/utilized/groupCourses/GroupCourseEnrolledStudents'

import { useHash } from 'utils/customHooks/useHash'

const GroupCourseCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const user = useSelector((state: RootState) => state['user'].user)

  const viewOnly = user?.role === 'special_teacher'

  const {hash} = useHash();

  const { data: groupCourse } = useGET_groupCourseByIdQuery(id)


  return ( <>
      { groupCourse && <>
        <PageHeading title={`${t('common.groups')} / 
          ${groupCourse.group?.title } / 
          ${groupCourse.course?.title}`} />
        <PageBody>
          <Tabs tabKey={hash || 'info'}>
            <CourseInfo id={ groupCourse.course_id } tabKey="info" tabText={`${t('common.overview')}`} />
            <GroupCourseEnrolledStudents viewOnly={viewOnly} id={groupCourse.id} tabKey="students" tabText={`${t('common.students')}`}/>
            <GroupCourseEnrolledTeachers viewOnly={viewOnly} id={groupCourse.id} tabKey="teachers" tabText={`${t('common.subject-teacher')}`}/>
            {/*<GroupCourseLessonPlans id={groupCourse.id} tabKey="lesson-plans" tabText={`${t('common.lesson-plans')}`}/>*/}
            <GroupCourseLessons groupCourse={groupCourse} tabKey="sessions" tabText={`${t('common.calendar')}`}/>
            <GroupCourseAssignments viewOnly={viewOnly} groupCourse={groupCourse} tabKey="assignments" tabText={`${t('common.assignments')}`}/>
            <GroupCourseGradebook viewOnly={viewOnly} groupCourse={groupCourse} tabKey="gradebook" tabText={`${t('common.gradebook')}`}/>
          </Tabs>
        </PageBody> 
      </>
      }  
    </> 
  )
}
export default GroupCourseCrudPage

const TabPlaceHolder = ({tabKey, tabText}) => {
  return(
    <p>{tabText}</p>
  )
}

